import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SvgComponent from '../SvgComponent';
import ButtonComponent from '../button/ButtonComponent';
import { LoadingComponent } from '../loading/LoadingComponent';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';
import { STATIC_ROOT, REWRITE_PREFIX, BRAND_NAME } from '../../constants';
import { traceBypassAdblocker } from '../../services/interstitiel/actions';
import { FormComponent, CheckboxInputFieldComponent } from '../../components/form';

import './AdBlockerModal.scss';

class AdBlockerModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            buttonEnabled: false,
            showError: false
        };
    }

    refreshPage() {
        window.parent.location = window.parent.location.href;
    }

    handleCheck = checked => {
        if (typeof checked === 'boolean') {
            this.setState({ buttonEnabled: checked });
        }
    };

    redirect = url => {
        if (url) {
            setTimeout(() => {
                window.location = url;
            }, 0);
        } else {
            console.error('An error occured, no redirection');
        }
    };

    submit = () => {
        const { urlRewritten, traceBypassAdblocker } = this.props;

        if (urlRewritten && urlRewritten.indexOf(REWRITE_PREFIX) !== -1) {
            let trackingCode = urlRewritten.substring(urlRewritten.indexOf(REWRITE_PREFIX));

            if (trackingCode.indexOf('&') !== -1) {
                trackingCode = trackingCode.substring(0, trackingCode.indexOf('&'));
            }

            traceBypassAdblocker(trackingCode, () => {
                this.redirect(urlRewritten);
            });
        } else {
            this.setState({ showError: true });
        }
    };

    showLoader = () => {
        const {
            adblockerBypassSubmitted,
            adblockerBypassFetching,
            adblockerBypassError
        } = this.props;

        return adblockerBypassFetching || (adblockerBypassSubmitted && !adblockerBypassError);
    };

    render() {
        const { i18n, adblockerBypassError } = this.props;
        const { buttonEnabled, showError } = this.state;

        return (
            <div className="adblocker-modal">
                <div className="header">
                    <img src={`${STATIC_ROOT}/logo.png`} alt={BRAND_NAME} width="130" height="53" />
                    <span className="warning">{i18n.INFO_MESSAGE}</span>
                </div>
                <div className="banner">
                    <SvgComponent src={`${STATIC_ROOT}/icon/info.svg`} width="18" height="18" />
                    {i18n.WARNING_MESSAGE}
                </div>
                <div className="content">
                    <p>{convertHtmlToReactDomWithParams(i18n.TEXT1)}</p>
                    <p>{i18n.TEXT2}</p>
                    <h3>{i18n.HOW_TO_TITLE}</h3>
                    <div className="step">
                        <SvgComponent src={`${STATIC_ROOT}/check.svg`} width="26" height="20" />
                        {i18n.STEP1_TEXT1}
                    </div>
                    <p>{i18n.STEP1_TEXT2}</p>
                    <p className="step">
                        <SvgComponent src={`${STATIC_ROOT}/check.svg`} width="26" height="20" />
                        {i18n.STEP2_TEXT1}
                    </p>
                    <p>{convertHtmlToReactDomWithParams(i18n.STEP2_TEXT2)}</p>
                </div>
                <div className="reload">
                    <ButtonComponent
                        text={i18n.RELOAD_BUTTON_TEXT}
                        color="main"
                        onClick={this.refreshPage}
                    />
                </div>
                <div className="pursue">
                    <FormComponent form={'FORM_NAME'} onSubmit={this.submit} hideButton>
                        <CheckboxInputFieldComponent
                            name="bypassAdblocker"
                            onChange={this.handleCheck}
                            options={[
                                {
                                    label: i18n.CHECKBOX_LABEL,
                                    value: true
                                }
                            ]}
                        />
                        {this.showLoader() ? (
                            <LoadingComponent />
                        ) : (
                            <ButtonComponent
                                type="submit"
                                color="sixth"
                                disabled={!buttonEnabled}
                                text={i18n.PURSUE_BUTTON_TEXT}
                            />
                        )}
                    </FormComponent>
                    {(showError || adblockerBypassError) && (
                        <p className="error">{i18n.ERROR_BYPASS}</p>
                    )}
                </div>
            </div>
        );
    }
}

AdBlockerModal.propTypes = {
    urlRewritten: PropTypes.string
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ADBLOCKER_MODAL,
        adblockerBypassSubmitted: state.interstitiel.adblockerBypassSubmitted,
        adblockerBypassFetching: state.interstitiel.adblockerBypassFetching,
        adblockerBypassError: state.interstitiel.adblockerBypassError
    };
};

const mapDispatchToProps = {
    traceBypassAdblocker
};

export default connect(mapStateToProps, mapDispatchToProps)(AdBlockerModal);



// WEBPACK FOOTER //
// ./src/components/adblocker/AdBlockerModal.js